import { reactive } from '@vue/composition-api'
import { apiEndpoint } from '@/configs/api/api-configs'

export default function tagModel() {
  const fetchTableTagList = reactive({
    api: `${apiEndpoint.bcrm_platform}/Tag/List`,
    method: 'POST',
    payload: {
      Page: 1,
      Limit: 30,
      Filters: [{ Seq: 1, Key: 'query', Value: '' }],
      Ordering: [
        { Seq: 1, Key: 'group_id', Direction: 'asc' },
        { Seq: 2, Key: 'seq', Direction: 'asc' },
      ],
    },
  })

  const fetchTagList = reactive({
    api: `${apiEndpoint.bcrm_platform}/Tag/Tag_List`,
    method: 'POST',
    payload: {},
  })

  const fetchTagInfo = reactive({
    api: `${apiEndpoint.bcrm_platform}/Tag/Info`,
    method: 'POST',
    payload: {
      Tag: 'free',
    },
  })

  const createTag = reactive({
    api: `${apiEndpoint.bcrm_platform}/Tag/Create`,
    method: 'POST',
    payload: {
      Tag: 'free-create-extra',
      String_Val: null,
      Int_Val: null,
      Decimal_Val: null,
      Bool_Val: true,
      DateTime_Val: null, // datetime
      Extra_Data: 'extra',
    },
  })

  const editTag = reactive({
    api: `${apiEndpoint.bcrm_platform}/Tag/Edit`,
    method: 'POST',
    payload: {
      Tag: 'free-create-extra',
      Tag_Name: 'free-create-extra',
      String_Val: null,
      Int_Val: null,
      Decimal_Val: null,
      Bool_Val: true,
      DateTime_Val: null, // datetime
      Extra_Data: 'extra-edited',
    },
  })

  const removeTag = reactive({
    api: `${apiEndpoint.bcrm_platform}/Tag/Delete`,
    method: 'POST',
    payload: {
      Tag: 'tier-choco3',
    },
  })

  return {
    fetchTableTagList,
    fetchTagList,
    fetchTagInfo,
    createTag,
    editTag,
    removeTag,
  }
}
